import { useLocation } from 'react-router';

import { useAppSelector as useSelector } from 'dux/app/hooks';

import { getPublicConsultationRoutes, getPublicConsultationRoutesQueries } from '../utils';

import { getConsultationAnswers, getIsConsultationLoading } from 'dux/consultation/selectors';

import { useConsultationCategory } from './useConsultationCategory';

export const useConsultationNotAccessible = () => {
  const isConsultationLoading = useSelector(getIsConsultationLoading);
  const consultationAnswers = useSelector(getConsultationAnswers);
  const consultationCategory = useConsultationCategory();
  const { pathname, search } = useLocation();

  return (
    !isConsultationLoading &&
    !consultationAnswers &&
    !getPublicConsultationRoutes(consultationCategory).includes(
      getPublicConsultationRoutesQueries.includes(search) ? pathname + search : pathname, // Add listed queries to public routes
    )
  );
};
